import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_9: FaireProductEntity = {
  token: "beverage-9",
  type: "product",
  name: "Organic Juice Collection",
  brandName: "Craft Beverages",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/02d67b5d3eb10a7b21cf9ba2a5a2c158f485d138d388b6279609aa1c3b2b6d56.webp",
  priceDollars: 18,
  msrpDollars: 28,
  freeShipping: true,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
